import { render, staticRenderFns } from "./ActiveGarageBlock.vue?vue&type=template&id=d13247d8"
import script from "./ActiveGarageBlock.vue?vue&type=script&lang=js"
export * from "./ActiveGarageBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../themes/custom/ef2_custom/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports